import type { TranscriptionQAEngine } from './type/qa-engine';
import type { TranscriptionResolver } from './type/resolver';
import type { Rule } from './type/rule';
import { getFetchedDataForRule } from './utils/transcription/fetch-data-for-rule';
import { createQaEngine } from './qa-engine';
export const createTranscriptionQAEngine = (rules: Rule<TranscriptionResolver>[]): TranscriptionQAEngine => {
  return createQaEngine(rules, getFetchedDataForRule);
};